import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'BoxQuote',
    props: {
        box: {
            required: true,
            type: Object,
        },
        schemaDisabled: {
            default: false,
            type: Boolean,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const isLongQuote = computed(() => (props.box.data?.text || '').length > 120);
        const isPersonBlock = computed(() => {
            const { text } = props.box.data || {};
            const { image, name } = props.box.data?.author || {};
            return !text && name && image && image.uri;
        });
        const withCite = computed(() => {
            const { name } = props.box.data?.author || {};
            return !isPersonBlock.value && name;
        });
        const isCiteWithImage = computed(() => {
            const { image } = props.box.data?.author || {};
            return withCite.value && image?.uri;
        });
        return {
            css,
            isLongQuote,
            isPersonBlock,
            withCite,
            isCiteWithImage,
        };
    },
});
